import { render, staticRenderFns } from "./board_brand.vue?vue&type=template&id=5110882d&scoped=true"
import script from "./board_brand.vue?vue&type=script&lang=js"
export * from "./board_brand.vue?vue&type=script&lang=js"
import style0 from "./board_brand.vue?vue&type=style&index=0&id=5110882d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5110882d",
  null
  
)

export default component.exports